import { IdentityService } from '@/services/identity-service';
import { Country } from '@/core/countries/interfaces';


export async function fetchCountries(): Promise<Array<Country>> {
    const { data, success } = await IdentityService.getCountries();

    if (!success) {
        return [];
    }

    return data.sort((a: any, b: any) => {
        if (!a.internationalName || !b.internationalName) {
            return 0;
        }

        if (a.internationalName < b.internationalName) {
            return -1;
        }

        if (a.internationalName > b.internationalName) {
            return 1;
        }

        return 0;
    });
}
